<template>
	<div class="watch-dashboard-widget pillbox-widget">
		<div class="watch-dashboard-widget-header">
			<router-link :to="{ name: 'WatchPillsManageByDate', params: { user_uid: user_uid, watch_id: watch_id } }" class="header-link">
				<h1>{{ $t('base.watch.medication') }}</h1>
			</router-link>
		</div>
		<div class="watch-dashboard-widget-body">
			<spinner v-if="pills.loading"/>
			<error-box v-else-if="pills.error" :error="pills.error"/>
			<div v-else>
				<div v-if="pills.data.length" class="pills">
					<router-link v-for="pill in pills.data" :key="pill.id" :to="{ name: 'WatchPillsManageByDate', params: { user_uid: user_uid, watch_id: watch_id } }" class="pill">
						<shape :src="svgSrc(pill.type)" :class="svgClass(pill.color)" class="pill-svg"/>
						<div class="info">
							<div><b>{{ pill.name }}</b></div>
							<div>{{ $t('labels.general.hour') }}: <b>{{ pill.hour | formatHour }}</b></div>
							<div>{{ $t('labels.general.dose') }}: <b>{{ pill.dose }}</b></div>
						</div>
					</router-link>
				</div>
				<p v-else>{{ $t('base.watch.no_medication_today') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import clamp from '@/utils/clamp'
import Pill from '@/classes/Pill'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			pills: {
				loading: false,
				data: [],
				error: null
			}
		}
	},
	watch: {
		'$route' () {
			this.getAllForToday()
		}
	},
	computed: {
		daysOfWeekMap () {
			return new Map([
				['Mon', 1],
				['Tue', 2],
				['Wed', 4],
				['Thu', 8],
				['Fri', 16],
				['Sat', 32],
				['Sun', 64]
			])
		},
		currentDay () {
			return this.$moment().format("ddd")
		}
	},
	methods: {
		svgSrc (shape) {
			return `/static/svg/pills/${this.numToShape(shape)}.svg`
		},
		svgClass (color) {
			return `color-${this.numToColor(color)}`
		},
		numToShape (n) {
			return `shape${n.toString().padStart(2, 0)}`
		},
		numToColor (n) {
			const colors = Pill.colors()
			n = clamp(parseInt(n), 0, colors.length - 1)
			return colors[n]
		},
		getAllForToday () {
			this.pills.loading = true
			this.pills.data = []
			const day = this.$moment().format('YYYY-MM-DD')
			this.$api.pillbox2.getByDay(this, this.user_uid, this.watch_id, day).then(response => {
				this.$log.info('watch dashboard pillbox', 'pillbox.getByDay OK', response)()
				this.pills.data = Pill.processResponse(response.body)
					.sort((a, b) => a.hour > b.hour)
			}).catch(error => {
				this.$log.error('watch dashboard pillbox', 'pillbox.getByDay ERROR', error)()
				this.pills.error = error
			}).finally(() => {
				this.pills.loading = false
			})
		},
	},
	mounted () {
		this.getAllForToday()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/PillboxWidget.vue